(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let videoSwiper = null;

    function initVideoSwiper() {
      const isDesktop = window.innerWidth >= 768;

      // Destroy existing Swiper instance
      if (videoSwiper) {
        videoSwiper.destroy(true, true);
        videoSwiper = null;
      }

      // Initialize Swiper
      videoSwiper = new Swiper('.review-card-slider', {
        pagination: isDesktop ? {
          el: '.swiper-pagination',
          type: 'progressbar',
          clickable: false,
        } : false,
        navigation: {
          nextEl: '.review-button-next',
          prevEl: '.review-button-prev',
        },
        autoHeight: true,
        mousewheel: isDesktop,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 17,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 39,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 39,
          },
        },
      });
    }

    initVideoSwiper();
    window.addEventListener('resize', initVideoSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let featureSwiper = null;

  function initfeatureSwiper() {
    if (window.innerWidth <= 767 && !featureSwiper) {
      featureSwiper = new Swiper('.feature-swiper', { // ← FIXED HERE
        slidesPerView: 'auto',
         spaceBetween: 17,
        autoHeight: true,
        navigation: {
          nextEl: '.feature-arrow-next',
          prevEl: '.feature-arrow-prev',
        },
      });
    } else if (window.innerWidth > 767 && featureSwiper) {
      featureSwiper.destroy(true, true);
      featureSwiper = null;
    }
  }

  initfeatureSwiper();
  window.addEventListener('resize', initfeatureSwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_text-with-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let featureSwiper = null;

  function initfeatureSwiper() {
    if (window.innerWidth <= 767 && !featureSwiper) {
      featureSwiper = new Swiper('.hb-feature-swiper', { // ← FIXED HERE
        slidesPerView: 2,
         spaceBetween: 0,
        autoHeight: true,
        navigation: {
          nextEl: '.hb-feature-arrow-next',
          prevEl: '.hb-feature-arrow-prev',
        },
      });
    } else if (window.innerWidth > 767 && featureSwiper) {
      featureSwiper.destroy(true, true);
      featureSwiper = null;
    }
  }

  initfeatureSwiper();
  window.addEventListener('resize', initfeatureSwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const popup = document.getElementById('offerPopup');
  const openBtn = document.getElementById('openPopupBtn');
  const closeBtn = document.getElementById('closePopupBtn');

  openBtn.addEventListener('click', () => popup.classList.add('active'));
  closeBtn.addEventListener('click', () => popup.classList.remove('active'));
  popup.addEventListener('click', (e) => {
    if (e.target === popup) popup.classList.remove('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-journey"] && !Shopify.designMode) return;
  try {
    
  const items = document.querySelectorAll('.timeline-item');
  const progressBar = document.querySelector('.progress-bar');

  items.forEach((item, index) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        progressBar.style.height = '0';
        return;
      }
      items.forEach((i) => i.classList.remove('active'));
      item.classList.add('active');
      const totalItems = items.length;
      const progressPercent = ((index + 1) / totalItems) * 100;
      progressBar.style.height = `${progressPercent}%`;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-people-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let videoSwiper = null;

    function initVideoSwiper() {
      if (videoSwiper) {
        videoSwiper.destroy(true, true);
        videoSwiper = null;
      }

      videoSwiper = new Swiper('.video-swiperr-wrapper', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
          clickable: false,
        },
        navigation: {
          nextEl: '.video-swiper-button-next',
          prevEl: '.video-swiper-button-prev',
        },
        mousewheel: true,
        breakpoints: {
          0: {
            slidesPerView: 1.9,
            centeredSlides: true,
            spaceBetween: 17,
            mousewheel: false,
          },
          768: {
            slidesPerView: 3,
            centeredSlides: true,
            spaceBetween: 39,
            mousewheel: true,
          },
          991: {
            slidesPerView: 3.5,
            spaceBetween: 30,
          },
          1440: {
            slidesPerView: 3.7,
            spaceBetween: 39,
          },
        },
      });

      // Toggle visibility of navigation and pagination
      const isMobile = window.innerWidth <= 767;
      document.querySelector('.video-swiper-button-next').style.display = isMobile ? 'flex' : 'none';
      document.querySelector('.video-swiper-button-prev').style.display = isMobile ? 'flex' : 'none';
      document.querySelector('.swiper-pagination').style.display = !isMobile ? 'block' : 'none';
    }

    initVideoSwiper();
    window.addEventListener('resize', initVideoSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["war-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const tabButtons = document.querySelectorAll('.tab-btn');
    const panels = document.querySelectorAll('.tab-panel');

    function activatePanel(targetId) {
      panels.forEach((p) => {
        const isTarget = p.id === targetId;
        p.classList.toggle('active', isTarget);
        p.setAttribute('aria-hidden', !isTarget);
      });
      tabButtons.forEach((btn) => {
        btn.classList.toggle('active', btn.getAttribute('data-target') === targetId);
        btn.setAttribute('aria-selected', btn.getAttribute('data-target') === targetId ? 'true' : 'false');
      });
    }

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-target');
        activatePanel(target);
      });
    });
  })();

  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.video-tab-slider', {
      slidesPerView: 1.5,
      spaceBetween: 28,
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 21,
        },
      },
    });

    // Video popup
    const modal = document.getElementById('videoModal');
    const iframe = document.getElementById('videoIframe');
    const closeBtn = document.querySelector('.video-close');

    document.querySelectorAll('.video-tab-slider .swiper-slide').forEach((slide) => {
      slide.addEventListener('click', () => {
        const videoUrl = slide.getAttribute('data-video-url');
        iframe.src = videoUrl;
        modal.style.display = 'flex';
      });
    });

    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
      iframe.src = '';
    });

    window.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
        iframe.src = '';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
